module.exports = __webpack_public_path__ + "img/alert.7702b74e.svg";